import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=531da5c1&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Sidebar.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531da5c1",
  null
  
)

export default component.exports